
import { IProductList } from '@homeserve/od-typings/api';
import { Vue, Component, Prop } from 'vue-property-decorator';
import WLProductListItem from './WLProductListItem.vue';

@Component({ components: { WLProductListItem } })
export default class WLProductList extends Vue {
  @Prop()
  public name!: string;

  @Prop({ type: String })
  public description!: string;

  @Prop()
  private list!: IProductList;

  @Prop({ type: Number, default: 4 })
  private count!: number;

  @Prop({ type: Boolean, default: true })
  public margin!: boolean;

  get productList() {
    return this.list.products.slice(0, this.count);
  }
}
